import { Inject, Injectable } from '@angular/core';
import { Appointment } from 'ag-common-lib/public-api';
import { DataService } from 'ag-common-svc/lib/services/data.service';
import { FirebaseApp } from 'firebase/app';
import { FIREBASE_APP } from 'ag-common-svc/lib/injections/firebase-app';

@Injectable({
  providedIn: 'root',
})
export class AppointmentService extends DataService<Appointment> {
  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    super(fireBaseApp);
    super.setCollection('appointments');
  }
}
